import request from '../../axios';

const postStoreOrder = async (payload: OrderPayload) => {
  const {data} = await request.post(`/api/v2/order/create-order`, payload);
  return data;
};

export default postStoreOrder;
